/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartHalf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.252 2.986a5.733 5.733 0 0 1 4.07 1.71 5.89 5.89 0 0 1 0 8.23l-8.33 8.49-8.33-8.49a5.92 5.92 0 0 1 0-8.23 5.692 5.692 0 0 1 6.27-1.264 5.69 5.69 0 0 1 1.86 1.264l.2.21.2-.21a5.672 5.672 0 0 1 4.06-1.71zm0 2.041a3.77 3.77 0 0 0-2.64 1.08L12 7.747v10.77l6.893-6.992a3.89 3.89 0 0 0 0-5.42 3.772 3.772 0 0 0-2.641-1.079z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeartHalf as HeartHalf };
